<template>
    <div>
        <v-dialog v-model="abrir" persistent >
            <v-card class="pb-1">
                <v-card-title class="justify-space-between">
                    <span class="headline">Editar Despacho Aceite</span>
                    <v-btn color="red darken-1" dark @click="cerrarModal">Cerrar</v-btn>
                </v-card-title>
                
            
                <v-col cols="12" class="mt-2 mb-4">
                    <v-row>
                        <v-col cols="2" class="d-flex flex-column">
                            <label class="font-weight-bold">Bodega Origen</label>
                            <span>{{ bodega_origen_texto }}</span>
                        </v-col>

                        <v-col cols="2" class="d-flex flex-column">
                            <label class="font-weight-bold">Nro de Embarque</label>
                            <span>{{ nro_embarque }}</span>
                        </v-col>

                        <v-col cols="2" class="d-flex flex-column">
                            <label class="font-weight-bold">Guía Despacho</label>
                            <span>{{ guia_despacho }}</span>
                        </v-col>

                        <v-col cols="2" class="d-flex flex-column">
                            <label class="font-weight-bold">Estanque</label>
                            <span>{{ estanque }}</span>
                        </v-col>

                        <v-col cols="2" class="d-flex flex-column">
                            <label class="font-weight-bold">Cant. Despachada</label>
                            <span>{{ cant_despachada }}</span>
                        </v-col>

                        <v-col cols="2">
                            <v-select
                                    v-model="es_preembarque"
                                    :items="lista_options"
                                    label="Es Asignación de Embarque"
                                    item-text="nombre"
                                    item-value="id"
                                    color="blue darken-3"
                                    persistent-hint
                            ></v-select>
                        </v-col>
                    </v-row>
                </v-col>

                <v-col cols="12">
                    <v-card>
                        <v-row class="pl-1 pr-1">
                            <v-col cols="3">
                                <v-select
                                    :items="bodegas"
                                    item-text="nombre"
                                    item-value="id"
                                    v-model="bodega_destino"
                                    label="Seleccione Bodega Destino"
                                ></v-select>
                            </v-col>
                            <v-col cols="3">
                                <label>Fecha Embarque</label>
                                <date-picker 
                                    v-model="fecha_despacho" 
                                    placeholder ="Seleccione Fecha"
                                    label ="Seleccione Fecha" 
                                    format="DD-MM-YYYY" 
                                    :default-value="fecha_despacho" 
                                    valueType="YYYY-MM-DD"
                                ></date-picker>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field v-model="nro_embarque" label="Nro de Embarque" placeholder="Nro de Embarque"></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field
                                        v-model="guia_despacho"
                                        label="Guía Despacho"
                                ></v-text-field>
                            </v-col>
                        <!-- INICIO DOCUMENTOS DINAMICOS -->
                            <v-col cols="3" class="pb-0 pt-0" v-for="(item) in datos_adicionales" :key="item.id">
                                <v-text-field v-if="item.tipo_dato == 'Texto'"
                                        v-model="item.valor_dato"
                                        :label="item.documento"
                                        class="pt-1 mb-1" 
                                ></v-text-field>
                                <v-text-field v-if="item.tipo_dato == 'Numero'"
                                        v-model="item.valor_dato"
                                        :label="item.documento"
                                        class="pt-1 mb-1" 
                                ></v-text-field>
                                <v-select v-if="item.tipo_dato == 'Select'"
                                        v-model="item.valor_dato"
                                        :items="item.opciones"
                                        item-text="opcion"
                                        item-value="id"
                                        :label="item.documento"
                                        class="pt-0 mb-1" 
                                ></v-select>
                                <v-file-input v-if="item.tipo_dato == 'Archivo'"
                                        v-model="item.valor_dato"
                                        outlined
                                        :label="item.documento"
                                        class="pt-1 mb-1" 
                                ></v-file-input>
                                <label v-if="item.tipo_dato == 'Fecha'" class="pt-0">{{item.documento}}</label>
                                <date-picker v-if="item.tipo_dato == 'Fecha'"
                                        v-model="item.valor_dato"
                                        placeholder ="Seleccione Fecha"
                                        :label="item.documento"
                                        format="DD-MM-YYYY"
                                        valueType="YYYY-MM-DD"
                                        class="pt-0 mb-1" 
                                ></date-picker>
                            </v-col>
                        <!-- FIN DOCUMENTOS DINAMICOS -->
                            
                        </v-row>

                        <v-row>
                            <v-progress-linear 
                                v-if="progreso_despacho"
                                indeterminate
                                color="#0D47A1"
                            ></v-progress-linear>
                        </v-row>
                        
                    </v-card>
                </v-col>
                <div class="d-flex justify-center pt-5 pb-4">
                    <v-btn color="blue darken-1" dark @click="modificar_despacho">Editar</v-btn>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {mapState, mapMutations} from 'vuex';
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

  export default {
    data:()=>({
        bodega_origen:'',
        bodega_origen_texto: '',
        bodega_destino:'',
        nro_embarque: '',
        info_embarque: [],
        es_preembarque: 0,
        cant_despachada: '',
        estanque: '',
        lista_options:[{"id":0, "nombre":'Despachado'}, {"id":1, "nombre":'Asignado'}],
        guia_despacho: '',
        despacho: {},
        fecha_despacho: new Date().toISOString().substr(0, 10),
        progreso_despacho: false,
        abrir: false,
    }),
    props: {
        bodegas: Array,
        datos_adicionales: Array,
        documentos: Array,
        estanques: Array,
    },
    mounted(){
        this.$parent.$on('abrir_modal_edit', async (despacho)=>{

            this.despacho = despacho;
            this.nro_embarque = despacho.nro_embarque;
            this.buscarEmbarque(despacho);
        });
    },
    methods: {
        async buscarEmbarque(){
            this.mostrarLoading({titulo:'Obteniendo información de despacho...',color:'blue'})
            let url = `${this.base_url}despacho_aceite/buscar_despacho/${this.despacho.id}`;
            await this.axios.get(url, this.headers).then(async (res)=>{
                this.info_embarque = res.data.data.info;
                this.bodega_origen = this.info_embarque.bodega_origen
                this.bodega_origen_texto = this.info_embarque.bodega_origen_texto;
                this.bodega_destino = this.info_embarque.bodega_destino
                this.fecha_despacho = this.info_embarque.fecha
                this.es_preembarque = this.info_embarque.es_preembarque;

                const data_guia = res.data.data.data.find(despacho => despacho.guia === this.despacho.guia);

                this.guia_despacho = data_guia.guia;
                this.cant_despachada = data_guia.cantidad;
                this.estanque = this.estanques.find(est => est.id === data_guia.estanques_externos_id).nombre;

                let info = this.info_embarque.informacion;
                info.forEach( row => {
                    try {
                        let idx = this.datos_adicionales.findIndex(r => r.mov_documentos_id == row.mov_documentos_id)
                        if (row.tipo_dato == "Fecha") {
                            this.$set(this.datos_adicionales[idx], "valor_dato", this.moment(row.valor_fecha).format('YYYY-MM-DD'));
                        } else {
                            this.$set(this.datos_adicionales[idx], "valor_dato", row.valor_dato);
                        }
                    } catch (err) {
                        console.log('error',err);
                    }
                });
                this.ocultarLoading();
                this.abrir = true;
            }).catch((error)=>{
                console.log('error',error);
            });
        },
        async modificar_despacho(){
            this.progreso_despacho = true;
            this.mostrarLoading({titulo:'Modificando despacho...',color:'blue'})
            let data = {}
            const id = this.despacho.id;

            data = {    "bod_origen": this.bodega_origen,
                        "bod_destino": this.bodega_destino,
                        "fecha": this.fecha_despacho,
                        "embarque": this.nro_embarque,
                        "preembarque": this.es_preembarque,
                        "guia": this.guia_despacho,
                        "datos_adicionales": this.datos_adicionales,
                    }

            let url = `${this.base_url}despacho_aceite/modificar_despacho/${id}`;
            await this.axios.put(url, data, this.headers).then((response) => {
                let resp = response.data.data;
                console.log("resp", resp.original.data[0])
                this.$emit('modal-cerrada', resp.original.data[0]);
                this.ocultarLoading();
                this.cerrarModal();
            }).catch((error)=>{
                this.errorMessage(error, "Error al modificar despacho");
                this.mostrarLoading({titulo:'Error al modificar despacho',color:'red'})
                console.log(error);
            });
            this.progreso_despacho = false;
            
        },
        cerrarModal() {
            this.abrir = false;
            this.$emit("limpiar_campos");
        },
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
      ...mapState(['base_url', 'headers', 'roles']),
    },
    components: { 
        DatePicker,
    }
  }
</script>

<style>
</style>